import _ from "lodash";
import React from "react";

import { Avatar, AvatarGroup } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";
import {
  MESSAGING_ACTIONS,
  getFormattedNameForUserType,
  recordChannelActions,
  isMessagingRevempEnabled,
} from "MessagingV2/modules/Utils";
import { getAvatarColor } from "Utils";
import { onEnterOrSpaceKeyDown } from "Utils/AccessibilityHelpers";

import classes from "./MemberList.scss";
import classNames from "classnames";

const UserAvatarContainer = ({
  isUIRevempEnabled,
  users,
  countOfHidedUsers,
}) => {
  const firstThreeUsers = _.slice(users, 0, 3);
  return !isUIRevempEnabled ? (
    <AvatarGroup
      dsVersion="2.0"
      shade={"light"}
      shape={"square"}
      size={"small"}
      max={3}
    >
      {_.map(users, user => (
        <Avatar
          name={getFormattedNameForUserType({
            user,
          })}
          color={getAvatarColor(user.id)}
          key={user.id}
        />
      ))}
    </AvatarGroup>
  ) : (
    <div className={classes.avatarWrapper}>
      {_.map(firstThreeUsers, user => {
        return (
          <div className={classes.avatarContainer} key={user.id}>
            <Avatar
              name={getFormattedNameForUserType({
                user,
              })}
              color={getAvatarColor(user.id)}
              size={"x-small"}
              shade={"light"}
              shape="square"
              dsVersion="2.0"
            />
          </div>
        );
      })}
      {countOfHidedUsers > 0 ? (
        <p className={classNames(classes.usersCount, "text-label-s")}>
          {countOfHidedUsers}
        </p>
      ) : null}
    </div>
  );
};

const MemberList = ({
  users,
  isArchived,
  isMemberUpdate,
  setChannelOptionsModalState,
}) => {
  const { t } = useI18n(["common"]);
  const isUIRevempEnabled = isMessagingRevempEnabled();

  const countOfHidedUsers = _.size(users);

  const handleManageMembersClick = () => {
    if (!isArchived) {
      setChannelOptionsModalState();
      recordChannelActions({
        type: MESSAGING_ACTIONS.MEMBERS,
        mode: isMemberUpdate ? "EDIT" : "VIEW",
      });
    }
  };

  const handleManageMembersKeyDown = e => {
    onEnterOrSpaceKeyDown(e, handleManageMembersClick);
  };

  return (
    <div
      className={
        isUIRevempEnabled
          ? classes.memberListContainerV2
          : classes.memberListContainer
      }
      onClick={handleManageMembersClick}
      onKeyDown={handleManageMembersKeyDown}
      role="button"
      tabIndex={isArchived ? -1 : 0}
      aria-disabled={isArchived}
      aria-label={t("common:view_members")}
    >
      <UserAvatarContainer
        isUIRevempEnabled={isUIRevempEnabled}
        users={users}
        countOfHidedUsers={countOfHidedUsers}
      />
      {countOfHidedUsers > 0 && !isUIRevempEnabled ? (
        <div
          className={
            isUIRevempEnabled
              ? classes.avatarContainerV2
              : classes.avatarContainer
          }
        >
          <div
            className={
              isUIRevempEnabled ? classes.countAvatarV2 : classes.countAvatar
            }
          >
            <p className="text-label-4">{countOfHidedUsers}</p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default MemberList;
